import {toast} from '@wandb/weave/common/components/elements/Toast';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {Tooltip} from '@wandb/weave/components/Tooltip';
import copyToClipboard from 'copy-to-clipboard';
import React from 'react';

import {truncateString} from '../../util/runhelpers';

type WebhookTableColumnURLProps = {
  url: string;
};

export const WebhookTableColumnURL = ({url}: WebhookTableColumnURLProps) => {
  // TODO: Replace truncateString() with TruncateText common component when its ready
  const onCopyClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    copyToClipboard(url);
    toast('URL copied to clipboard');
  };
  return (
    <Tailwind>
      <Tooltip
        trigger={
          <div
            onClick={onCopyClick}
            className={`cursor-pointer truncate hover:font-semibold`}>
            {truncateString(url, 40)}
          </div>
        }
        content={url}
        position="bottom right"
      />
    </Tailwind>
  );
};
